import { Component, OnInit, Input, ElementRef } from '@angular/core';

import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-image-cropper-popup',
	templateUrl: './image-cropper-popup.component.html',
	styleUrls: ['./image-cropper-popup.component.scss']
})

export class ImageCropperPopupComponent implements OnInit {
	imageChangedEvent: any = '';
	// @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent
	@Input() croppedImage: any = null;
	imageAspectRatio: any = null;
	cropperConfig = {
		aspectRatio: 4 / 3,
		resizeToWidth: 800,
		imageFormat: "png",
		minWidth: 600
	};

	constructor(public activeModal: NgbActiveModal, private el: ElementRef) { }

	ngOnInit(): void {
		console.log(this.cropperConfig);
		this.fileChangeEvent(this.croppedImage);
	}

	fileChangeEvent(event: any): void {
		this.imageChangedEvent = event;
	}

	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
	}

	imageLoaded() {
		console.log("show cropper");
		// show cropper
	}

	cropperReady(event) {
		console.log("cropper ready");
	}

	loadImageFailed() {
		console.log("show Failed message");
	}

	closeModal(sendData) {
		this.activeModal.close(sendData);
	}

}
